module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"CompletedWork":"Completed Work","ID":"ID","OriginalEstimate":"Original Estimate","ProjectName":"Nom de projet","Velocity":"Vélocité","TasksInError":"Nombre de tâches en erreur","Title":"Titre"}}')
  delete Component.options._Ctor
}
